module.exports = __webpack_public_path__ + "static/media/graceIcon.89647de9.jpg";